import { string, object, array } from 'yup';

const schema = object().shape({
  name: string().required('Name is required'),
  privileges: array()
});

export default { create: schema, edit: schema };
